import React from 'react';

const Loading = ({ size = 'medium', colorVariant = 'primary', text = null, className = '' }) => {
  const sizeClass = `loading__spinner--${size}`;
  const variantClass = `loading__spinner--${colorVariant}`;

  return (
    <div className={`loading ${className}`}>
      <div className={`loading__spinner ${sizeClass} ${variantClass}`}>
        <div className="loading__spinner-circle"></div>
        <div className="loading__spinner-circle"></div>
        <div className="loading__spinner-circle"></div>
        <div className="loading__spinner-circle"></div>
      </div>
      {text && <div className="loading__text">{text}</div>}
    </div>
  );
};

export default Loading;
